import { memo, ReactNode, useMemo } from "react";
import useSessionStorageState from "use-session-storage-state";
import { UserSettingContext, UserSettings } from "./UserSettingsContext";

export type UserSettingsSessionStorageProviderProps = {
  children: ReactNode | ReactNode[],
  settingKey?: string
}

export const UserSettingsSessionStorageProvider = memo<UserSettingsSessionStorageProviderProps>(({ children, settingKey = "mimicUserSettings" }) => {
  const [ settings, setSettings ] = useSessionStorageState(settingKey, {
    defaultValue: {},
  });

  const value = useMemo((): UserSettings => {
    return ({
      initialized: !!settings,
      saveSetting: (id: string, value: any) => {
        setSettings({
          ...(settings || {}),
          [id]: value,
        });
      },
      settings: settings || {},
    });
  }, [ settings, setSettings ]);

  return (
    <UserSettingContext.Provider value={value}>
      {children}
    </UserSettingContext.Provider>
  );
});